import { SubTaskTab, TaskTab } from '../../../requests/tasks.model';

/** Index used when no navigation item matches the current route. */
export const NO_ACTIVE_ITEM = -1;

export interface SidebarNavItem {
    label: string;
    icon: string;
    testId: string;
    tab?: TaskTab | SubTaskTab;
}

export const TASK_OWNER_REQUEST_ITEMS: SidebarNavItem[] = [
    {
        tab: TaskTab.UNASSIGNED,
        label: 'common.tasks.unassigned',
        icon: 'open',
        testId: 'emea-tasks-tab-unassigned'
    },
    {
        tab: TaskTab.ASSIGNED_TO_ME,
        label: 'common.tasks.assigned-to-me',
        icon: 'checkmark',
        testId: 'emea-tasks-tab-assigned-to-me'
    },
    {
        tab: TaskTab.CREATED_REQUESTS,
        label: 'common.tasks.created-by-me',
        icon: 'table-out',
        testId: 'emea-requests-tab-created'
    },
    {
        tab: TaskTab.MDLA_REQUESTS,
        label: 'common.tasks.all-requests',
        icon: 'observations',
        testId: 'emea-tasks-tab-all-requests'
    }
];

export const REQUESTOR_REQUEST_ITEMS: SidebarNavItem[] = [
    {
        tab: TaskTab.CREATED_REQUESTS,
        label: 'common.tasks.created-by-me',
        icon: 'table-out',
        testId: 'emea-requests-tab-created'
    },
    {
        tab: TaskTab.MY_RESPONSE_NEEDED,
        label: 'common.tasks.my-response-needed',
        icon: 'open-tasks',
        testId: 'emea-tasks-tab-my-requests'
    }
];

export const SUBTASK_ITEMS: SidebarNavItem[] = [
    {
        tab: SubTaskTab.UNASSIGNED,
        label: 'common.tasks.unassigned',
        icon: 'open',
        testId: 'emea-subtasks-tab-unassigned'
    },
    {
        tab: SubTaskTab.ASSIGNED_TO_ME,
        label: 'common.tasks.assigned-to-me',
        icon: 'checkmark',
        testId: 'emea-subtasks-tab-assigned-to-me'
    },
    {
        tab: SubTaskTab.CREATED,
        label: 'common.tasks.created-by-me',
        icon: 'table-out',
        testId: 'emea-subtasks-tab-created'
    },
    {
        tab: SubTaskTab.ALL,
        label: 'common.tasks.all-subtasks',
        icon: 'observations',
        testId: 'emea-subtasks-tab-all'
    }
];
